import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_NO_ACCESS } from "@assets/svgs/ICON_NO_ACCESS.svg";
import { Icon } from "@components/Icon";
import { Text } from "@components/Text";
import { COLOR_WHITE } from "@static/COLORS";

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const SectionLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default () => {
  return (
    <SectionContainer>
      <SectionLogo>
        <Icon width={256} height={256}>
          <ICON_NO_ACCESS />
        </Icon>
        <Text fontSize="96px" fontWeight="600" color={COLOR_WHITE}>
          No Access
        </Text>
        {/* <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <Button onClick={() => onHandleRedirect()}>
            <Text
              align="end"
              fontSize="16px"
              fontWeight="600"
              color={COLOR_WHITE}
              textDecorationLine="underLine"
            >
              back
            </Text>
          </Button>
        </div> */}
      </SectionLogo>
    </SectionContainer>
  );
};
